module.exports = __webpack_public_path__ + "static/media/snare-808.80c4129b.wav";